module.exports = __webpack_public_path__ + "img/4.641ab36c.png";